import { ViewChild, Component, ViewEncapsulation, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { SharedServiceService } from '../app/services/shared-service.service'
import { Subject, Subscription } from 'rxjs';
import { LocalStorageService } from '../app/services/local-storage.service';
import { CategorizationService } from "../app/services/categorization.service";
import { ConfigurationService } from './services/configuration.service';
import { ConfigurationLockService } from './services/configuration-lock.service';
import { UnSavedChangesServiceService } from './services/un-saved-changes-service.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { filter, take } from 'rxjs/operators';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { serverMessage } from './popUpMessages/serverMessage';
import { messages } from './popUpMessages/messages';
import { ToasterService } from './services/toaster.service';

//Defined Global variables
let countryCode;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None

})
export class AppComponent implements OnInit, OnDestroy {
  public Identifier: any;
  public CurrencyFromDB: any;
  public currency: any;
  public Productivity: any;
  public dataRecived: any;
  public ProductivityFCEUR: any;
  public productivity: any;
  public ProjectId: any;
  public ProjectTitle: any;
  public businessAreaid: any;
  public businessLineId: any;
  public DifferCurrencyText: string = "Dear user, you selected two KMATs from different plants with different currencies. Please be aware that the shown values in the application are not being translated into a common currency. Therefore, shown sums are not correct, please use our Power BI reporting solution to see the values in Group Currency.";
  private routerSubscription: Subscription;

  @ViewChild('sidenav') sidenav: any;
  @ViewChild('sidehelp') sidehelp: any;

  title = 'eco';
  navopened: boolean = true;
  helpopened: boolean = false;
  sideHelpOpen: boolean = false;
  loggedIn = false;
  isIframe = false;
  sidenavopened: boolean = true;
  fixed: any = 7;
  username: string = ""
  userInfo: any;
  ideaIdAndTitle: Subject<any> = new Subject<any>();
  idea: any;
  userAccount: any;
  maxValue: any = 50;
  product: any;
  marqueeMessage: string = "";
  currencyValueFromCategorization = '';
  MilestoneName: any;
  ConFiguration: any = [];

  configurationID: any;
  lastConfigId: number | null = null;
  Stand: any;
  projectData: any;
  hasDifferentCurrencies: boolean = false;

  //Locking/Unlocking variables
  isReadOnly: boolean = true;
  isShowName: boolean = false;
  isDisabledStartEditing: boolean = true;
  lockedByUserName: string | null = null;
  lockedUserloggedIn: boolean = false;
  lockStatus: any = null;
  private currentUserId: number | null = null;  // Local tracking
  private remainingTime$: number | null = null; // Local tracking

  // Define the routes where locking is applicable
  // private readonly LOCKED_ROUTES = [
  //   '/tc-eq',
  //   '/tc-cs',
  //   '/tc-scm',
  //   '/tc-localcosts',
  //   '/plc-tc-directcost',
  //   '/tc-investmentplan',
  //   '/plc-tc-summary'
  // ];

  constructor(
    public router: Router,
    private cdr: ChangeDetectorRef,
    private sharedService: SharedServiceService,
    private LocalStorageService: LocalStorageService,
    private catService: CategorizationService,
    private localStorageService: LocalStorageService,
    private configurationkservice: ConfigurationService,
    private configurationLockService: ConfigurationLockService,
    private unSavedChangeService: UnSavedChangesServiceService,
    public dialog: MatDialog,
    private toastForExpire: ToasterService
  ) { }

  ngOnInit(): void {
    window.onunload = () => {
      // Clear the local storage of categorization on close of page tab or on refresh;    
      this.sharedService.onRemoveCategorizationData();

    }
    //Get Country Code
    countryCode = this.LocalStorageService.get('countryCode');
    this.catService.currentMsg.subscribe(x => this.currency = x);
    this.sharedService.currentUser.subscribe((user: any) => {
      this.currentUserId = user ? user.UserId : null;
    });
    setTimeout(() => {
      this.sharedService.data.subscribe((data) => {
        this.dataRecived = data;
        this.Identifier = this.dataRecived.ideaId;
        this.product = this.dataRecived.title;
        this.CurrencyFromDB = this.dataRecived.currency;
        this.currency = this.CurrencyFromDB;
        this.productivity = this.dataRecived.productivity;
        countryCode = this.LocalStorageService.get('countryCode');
        this.ProductivityFCEUR = new Intl.NumberFormat(countryCode).format(Number(parseFloat(this.productivity).toFixed(2)));
        this.marqueeMessage = this.dataRecived.marqueeMessage;
        if (!this.marqueeMessage) {
          this.marqueeMessage = '';
        }

        if (this.product) {
          if (this.dataRecived.title.length <= this.maxValue) {
            this.Productivity = this.dataRecived.title;
          }
          else {
            this.Productivity = this.dataRecived.title.substr(0, this.maxValue) + '...';
          }
        }
        else {
          this.Productivity = null;
        }

      });

      this.sharedService.projectData.subscribe((data) => {
        this.dataRecived = data;
        this.ProjectId = data.projectId;
        this.ProjectTitle = data.title;
        this.businessAreaid = data.businessAreaId;
        this.businessLineId = data.businessLineId;
        this.MilestoneName = data.milestoname;
        this.ConFiguration = data.configuration;
        this.configurationID = data.selectedConfiguration;

        if (data.configuration != null && data.configuration?.length != 0) {
          //this.configurationID = this.ConFiguration[0].Id;
          this.sharedService.changeConfigId(this.configurationID);
          this.Stand = data.stand;
          //this.localStorageService.set("ConfigId", this.configurationID);

          this.configurationkservice.GetConfigurationDetails(this.configurationID).subscribe((res: any) => {
            if (res.StatusCode == 200) {
              this.projectData = res.Data.StandFlags;

              this.Stand = res.Data.StandFlags;
            }
          })
          this.configurationkservice.GetLinkKMATDetails(this.configurationID).subscribe((res: any) => {
            if (res.StatusCode == 200) {

              if (res.Data != null) {
                this.currency = res.Data.LocalCurrency;
                this.hasDifferentCurrencies = res.Data.HasDifferentCurrencies;
              }
              else {
                this.currency = null;
                this.hasDifferentCurrencies = false;
              }
            }

          })
          // Call fetchLockStatus ONCE when all IDs are available
          if (this.currentUserId && this.ProjectId && this.configurationID) {
            this.configurationLockService.fetchLockStatus(
              this.configurationID,
              this.ProjectId,
              this.currentUserId
            );
          }
        }
        if (this.ProjectId) {
          if (this.dataRecived.title.length <= this.maxValue) {
            this.ProjectTitle = this.dataRecived.title;
          }
          else {
            this.ProjectTitle = this.dataRecived.title.substr(0, this.maxValue) + '...';
          }
        }
        else {
          this.ProjectTitle = null;
        }
      })
    }, 50)

    // Subscribe to lock status changes
    this.configurationLockService.lockStatus$.subscribe(lockStatus => {
      if (lockStatus !== null) {
        this.lockStatus = lockStatus;
        if (lockStatus.isLocked) {
          if (lockStatus.lockedByUserId === this.currentUserId) {
            this.lockedUserloggedIn = true;
            this.isReadOnly = false;
            this.isShowName = false;
            this.isDisabledStartEditing = false;
            this.lockedByUserName = lockStatus.lockedByUserName;
          }
          else {
            this.lockedUserloggedIn = false;
            this.isReadOnly = true;
            this.isShowName = true;
            this.isDisabledStartEditing = true;
            this.lockedByUserName = lockStatus.lockedByUserName;
          }
        } else {
          this.lockedUserloggedIn = false;
          this.isReadOnly = true;
          this.isShowName = false;
          this.isDisabledStartEditing = false;
          this.lockedByUserName = null;
        }
        //   if (lockStatus.lockedByUserId === this.currentUserId) {
        //     this.isReadOnly = false;
        //     this.lockedByUserName = lockStatus.lockedByUserName;
        //   } else {
        //     this.isReadOnly = true;
        //     this.lockedByUserName = lockStatus.lockedByUserName;
        //   }
        // } else {
        //   this.isReadOnly = false;
        //   this.lockedByUserName = null;
        // }
      }
    });

    this.configurationLockService.remainingTime$.subscribe(remainingTime => {
      this.remainingTime$ = remainingTime !== null ? remainingTime : null;

      if (this.remainingTime$ === 0) {
        this.configurationLockService.unlockConfiguration(this.configurationID, this.ProjectId, this.currentUserId);
        this.isReadOnly = true;
        this.isShowName = false;
      }
    });

    // Subscribe to warning alert
    this.configurationLockService.showWarning.subscribe(showWarning => {
      if (showWarning) {
        this.openAlertDialog([{ [messages.EditLockExpireWarning]: serverMessage.warning }]);

      }
    });

    // this.routerSubscription = this.router.events
    //   .pipe(filter(event => event instanceof NavigationStart))
    //   .subscribe((event: NavigationStart) => {
    //     this.handleRouteChange(event.url);
    //   });

  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
  changeVal() {
    return this.product
  }

  // private handleRouteChange(newUrl: string): void {
  //   const currentUrl = this.router.url;

  //   // Check if navigating FROM a locked route TO a non-locked route
  //   const isLeavingLockedRoute = this.isLockedRoute(currentUrl);
  //   const isGoingToLockedRoute = this.isLockedRoute(newUrl);

  //   // If user has lock and is leaving locked routes area
  //   if (isLeavingLockedRoute && !isGoingToLockedRoute) {
  //     this.unlockOnNavigation();
  //   }
  // }

  // private isLockedRoute(url: string): boolean {
  //   // Check if the URL matches any locked route (including sub-routes)
  //   return this.LOCKED_ROUTES.some(route =>
  //     url === route || url.startsWith(route + '/') || url.startsWith(route + '?')
  //   );
  // }

  // private async unlockOnNavigation(): Promise<void> {
  //   // Check if current user has the lock
  //   const lockStatus = this.configurationLockService.getCurrentLockStatus();

  //   if (lockStatus?.isLocked &&
  //     lockStatus?.lockedByUserId === this.currentUserId &&
  //     this.configurationID &&
  //     this.ProjectId &&
  //     this.currentUserId) {

  //     // this.configurationLockService.unlockConfiguration(
  //     //     this.configurationID,
  //     //     this.ProjectId,
  //     //     this.currentUserId
  //     //   );
  //     // Check for unsaved changes before unlocking
  //     // this.unSavedChangeService.requestCheck();
  //     // const proceed = await this.unSavedChangeService.checkResponse$.pipe(take(1)).toPromise();
  //     // if (proceed === true) {
        
  //     //   this.isReadOnly = true;
  //     //   this.cdr.detectChanges();
  //     // }
  //   }
  // }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  getRoute() {
    if (this.router.url == "/home") {
      return "mainside-container";
    }
    else {
      return "main-container";
    }
  }

  toggleSideNav() {
    this.sidenav.toggle();
    this.sidenavopened = !this.sidenavopened
  }

  toggleHelpNav() {
    this.sidehelp.toggle();
    this.sideHelpOpen = !this.sideHelpOpen;
    if (this.fixed == 238) {
      this.fixed = 7;
    }
    else if (this.fixed == 7) {
      this.fixed = 238;
    }
  }

  onConfigDropdownFocus() {
    this.lastConfigId = this.configurationID;
  }

  openAlertDialog(error) {
    this.dialog.open(AlertDialogComponent, { data: error })
  }

  ConfigurationChanged() {
    if (
      this.lockStatus &&
      this.lockStatus.isLocked &&
      this.lockStatus.lockedByUserId === this.currentUserId
    ) {
      // Show popup and do not proceed
      this.openAlertDialog([{ [messages.ChangeConfigurationError]: serverMessage.warning }]);
      setTimeout(() => {
        this.configurationID = this.lastConfigId;
        this.cdr.detectChanges();
      });
      return; // Stop here
    }

    this.sharedService.summaryLoading.next(true); // Show loader
    this.configurationkservice.GetConfigurationDetails(this.configurationID).subscribe((res: any) => {
      if (res.StatusCode == 200) {
        this.projectData = res.Data.StandFlags;

        this.Stand = res.Data.StandFlags;
      }
      this.sharedService.summaryLoading.next(false); // Hide loader after config details
    })
    this.configurationkservice.GetLinkKMATDetails(this.configurationID).subscribe((res: any) => {
      if (res.StatusCode == 200) {
        if (res.Data != null) {
          //  this.projectData = res.Data.Currency;
          this.hasDifferentCurrencies = !!res.Data.HasDifferentCurrencies; // <-- update flag
          this.currency = res.Data.LocalCurrency; // <-- update currency
        }
        else {
          this.currency = null;
          this.hasDifferentCurrencies = false;
        }
      }
    })
    this.localStorageService.set("ConfigId", this.configurationID);
    this.sharedService.changeConfigId(this.configurationID);
    this.configurationLockService.fetchLockStatus(this.configurationID, this.ProjectId, this.currentUserId);
  }

  async onToggle(event: MatSlideToggleChange) {
    if (event.checked && this.currentUserId && this.configurationID && this.ProjectId) {
      this.configurationLockService.lockConfiguration(this.configurationID, this.ProjectId, this.currentUserId)
        .subscribe((data: any) => {
          if (data && data.StatusCode == 200) {
            const lockedConfigId = data.Data[0].ConfigId;
            if ((Number(lockedConfigId) !== Number(this.configurationID))) {
              this.openAlertDialog([{ [messages.MultipleLockError + " on Configuration Id: " + lockedConfigId + ", Configuration Name: " + data.Data[0].ConfigName]: serverMessage.warning }]);
              event.source.checked = false;
              this.isReadOnly = true;
              this.cdr.detectChanges();
              return;
            }
            // Lock successful, UI already updated by lockStatusSubject
          }
        });
    }
    else if (!event.checked && this.currentUserId && this.configurationID
      && this.ProjectId &&
      this.configurationLockService.getCurrentLockStatus().isLocked &&
      this.configurationLockService.getCurrentLockStatus().lockedByUserId === this.currentUserId) {

      // Request check FIRST, then wait for response
      this.unSavedChangeService.requestCheck();

      // Wait for the user's response from the dialog
      const proceed = await this.unSavedChangeService.checkResponse$.pipe(take(1)).toPromise();
      // const proceed = await this.unSavedChangeService.checkResponse$.pipe(take(1)).toPromise();
      if (proceed === true) {
        this.configurationLockService.unlockConfiguration(this.configurationID, this.ProjectId, this.currentUserId);
        this.isReadOnly = true;
        event.source.checked = !this.isReadOnly;
        this.cdr.markForCheck();
      } else {
        // Revert the toggle back ON
        this.isReadOnly = false;
        event.source.checked = !this.isReadOnly;
        this.cdr.markForCheck();
      }
    }
  }
}
